// @flow
import { conditionMatcherFor, type Where } from './object-query-matcher';
import { type User } from './user';
import { type Customer } from './customer';
import type { Catalog } from './catalog';

export const internationalDefault = 'international';
export const northAmericanDefault = 'northAmerican';

type PaperSizeStandard = 'international' | 'northAmerican';

// helper function that finds the setting for the user, customer and catalog
export const paperSizeSetting = (
  user: User | null,
  customer: Customer | null,
  catalog: Catalog | null,
  setting?: $ReadOnlyArray<{|
    where: Where,
    standard: PaperSizeStandard,
  |}> | null,
): PaperSizeStandard | null => {
  const matchingSettings = Array.isArray(setting)
    ? setting
        .filter(conditionMatcherFor(customer, 'customer'))
        .filter(conditionMatcherFor(catalog, 'catalog'))
        .filter(conditionMatcherFor(user, 'user'))
    : null;

  return Array.isArray(matchingSettings) && matchingSettings.length > 0
    ? matchingSettings[0].standard
    : null;
};

// helper that determines the active paper size standard based on
// platform default, setting, and user preference
export const paperSizeStandard = (
  platformDefault: PaperSizeStandard,
  setting?: PaperSizeStandard | null,
  preference?: PaperSizeStandard | null,
): PaperSizeStandard => preference || setting || platformDefault;

export const activePaperSizeStandard = (
  user: User | null,
  customer: Customer | null,
  catalog: Catalog | null,
  preference?: PaperSizeStandard | null,
  setting?: $ReadOnlyArray<{|
    where: Where,
    standard: PaperSizeStandard,
  |}> | null,
): PaperSizeStandard => {
  const settingStandard =
    customer && user && catalog && Array.isArray(setting)
      ? paperSizeSetting(user, customer, catalog, setting)
      : null;

  return paperSizeStandard(northAmericanDefault, settingStandard, preference);
};
